<template>
    <div class="content-area row at-row no-gutter is-rest-of-height">
        <SideMenu v-on:tab-selected="onTabSelected" />
        <SideMenuOptions 
            v-bind:selectedTab = "this.selectedTabName"
            v-bind:bezieAppObj = "this.bezieAppObj" />
        <div class="is-rest-col use-bscroll">  
            <Playground v-bind:bezieAppObj = "this.bezieAppObj"/>
            <ControlSliders v-if="shouldShowSliders"  v-bind:bezieAppObj="this.bezieAppObj" style="position: absolute; bottom: 10px; height: 25%"/>
        </div>
    </div>
</template>

<script>
import SideMenu from './sidemenu/SideMenu.vue'
import SideMenuOptions from './sidemenu/SideMenuOptions.vue'
import Playground from './Playground.vue'
import ControlSliders from './playground/ControlSliders.vue'
import { UIUpdate } from '../lib/bezieLib/UI/UIUpdate'


export default {
    name: 'ContentArea',
    props: ['bezieAppObj'],
    components: {
        SideMenu,
        SideMenuOptions,
        Playground,
        ControlSliders
    },
    data: function(){
        return{
            selectedTabName : "Shapes",
            shouldShowSliders : true
        }
    },
    watch: {
        bezieAppObj : function(val){
            console.log("loaded bezie app obj in content area");
            if(this.bezieAppObj){
                this.updateUI();
                UIUpdate.addFeatureFlagChangeListener(this);
            }
        }
    },
    methods: {
        onTabSelected: function(tabName){
            console.log('on Tab Selected name:'+tabName);
            this.selectedTabName = tabName;
        },
        updateUI(){
            this.shouldShowSliders =  this.bezieAppObj.featureFlags.enableAnimations;
        },
        onFeatureFlagUpdate : function(){
            this.updateUI();
        }
    },
    beforeDestroy: function(){
        if(this.bezieAppObj){
            UIUpdate.removeFeatureFlagChangeListener(this);
        }
    }
}
</script>

<style scoped>
.is-rest-of-height{
    height: calc(100% - 50px);
}

.is-rest-col {
    background: whitesmoke;
    overflow: auto;
    display: block;
    flex-basis: 0;
    flex-grow: 1;
    flex-shrink: 1;
    position: relative;
}
</style>
